module.exports = __webpack_public_path__ + "img/img_common_proshow_normal.729faaa4.png";